module.exports = __webpack_public_path__ + "static/scale-model-of-chambers-bay-golf-course-in-tacoma-washington-eed13e57d27fdaba42d3d03685c92073.png";